import Vue from 'vue';
import Router from 'vue-router';

import List from '@/sections/List';
import ClientData from '@/sections/ClientData';
import Payment from '@/sections/Payment';
import Check from '@/sections/Check';

Vue.use(Router);
const url = window.groovie.url;

export default new Router({
    base: url.base,
    mode: 'history',
    routes: [
        {
            path: '',
            name: 'cart',
            component: List
        },
        {
            path: url.client,
            name: 'client',
            component: ClientData
        },
        {
            path: url.payment,
            name: 'payment',
            component: Payment
        },
        {
            path: url.check,
            name: 'check',
            component: Check
        },
        {
            path: url.fail,
            name: 'fail',
            component: Check
        }
    ]
});

export const breadcrumb = [
    'cart',
    'icon_next',
    'client',
    'icon_next',
    'payment',
    'icon_next',
    'check'
];



// WEBPACK FOOTER //
// ./src/router/index.js